<template>
    <div class="plans-wrapper" v-if="getAvailablePlanTypes().length  > 0">
        <div class="plans-wrapper-title">{{ $t("billing.plans") }}</div>
        <div class="plans-wrapper-content">
            <PlanItem
                v-for="type in getAvailablePlanTypes()"
                :key="type"
                :type="type"
            />
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import _ from "lodash";
import PlanItem from "./PlanItem.vue";
import { PLAN_TYPES } from "../utils/util";

export default {
    name: "Plans",
    components: { PlanItem },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            currentPlans: (state) => state.site.currentPlans,
            plans: (state) => state.site.plans,
        }),
    },
    methods: {
        getAvailablePlanTypes() {
            const currentPlanTypes = this.currentPlans.map((currentPlan) => currentPlan.planType);
            const staticPlanTypes = Object.values(PLAN_TYPES);
            const availablePlans = [...this.plans, ...staticPlanTypes.map((type) => ({ type }))].filter((plan) => !["extra-package", "feature", ...currentPlanTypes].includes(plan?.type));
            return _.uniq(availablePlans.map((plan) => plan.dynamicType || plan.type));
        },
    },
};
</script>
<style lang="scss" scoped>
.plans-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    padding: 20px;

    &-title {
        font-size: 20px;
        font-weight: 600;
    }

    &-content {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        grid-gap: 10px;
        background: #F1F4F7;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 10px;
    }
}
</style>
